import { unavailableReasonText } from '@/lib/ymarket-pricing'

export function UnavailableValue({ reason }: { reason: string }) {
  return (
    <span data-unavailable-reason={reason} title={reason} className="text-[12px] italic leading-4 text-ink-muted">
      {unavailableReasonText(reason)}
    </span>
  )
}
